import { Component, inject } from '@angular/core';
import { PwaUpdateService } from '../core/pwa-update.service';
import { AppActivityService } from '../core/app-activity.service';

@Component({
  selector: 'app-update-banner',
  standalone: true,
  template: `
    @if (pwa.updateReady()) {
      <div class="update-banner" role="status">
        <span>A new version is ready. It will apply automatically when you're done.</span>
        @if (!activity.busy()) {
          <button type="button" class="apply" (click)="apply()">Apply now</button>
        }
      </div>
    }
  `,
  styles: [`
    .update-banner {
      display: flex; align-items: center; gap: .75rem;
      padding: .625rem 1rem; background: #0e7490; color: #fff;
    }
    .update-banner span { flex: 1; }
    .update-banner button.apply {
      padding: .375rem .875rem; border: 0; border-radius: .375rem;
      background: #fff; color: #0e7490; font-weight: 600;
    }
  `],
})
export class UpdateBannerComponent {
  protected pwa = inject(PwaUpdateService);
  protected activity = inject(AppActivityService);
  apply(): void { void this.pwa.apply(); }
}
